'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const ActionsPhone = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("g", {
                clipPath: "url(#Phone_svg__clip0_869_5475)",
                children: /*#__PURE__*/ jsx("path", {
                    fill: "currentColor",
                    d: "M4.408 11.563C6.917 14.069 9.95 16 12.425 16c1.1 0 2.075-.391 2.858-1.249.45-.508.717-1.082.717-1.656 0-.475-.175-.924-.625-1.24l-2.567-1.824c-.408-.291-.75-.424-1.058-.424-.4 0-.75.224-1.142.616l-.616.607a.45.45 0 0 1-.325.125.8.8 0 0 1-.35-.1c-.525-.291-1.442-1.074-2.284-1.906-.833-.84-1.625-1.748-1.908-2.281a.8.8 0 0 1-.1-.35c0-.108.033-.224.125-.316l.608-.624c.392-.392.617-.741.617-1.14 0-.309-.133-.65-.425-1.058L4.133.633C3.817.19 3.35 0 2.858 0c-.566 0-1.141.241-1.641.716C.375 1.506 0 2.489 0 3.588c0 2.472 1.908 5.478 4.408 7.975"
                })
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "Phone_svg__clip0_869_5475",
                    children: /*#__PURE__*/ jsx("path", {
                        fill: "white",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    })));

export { ActionsPhone, ActionsPhone as default };
//# sourceMappingURL=ActionsPhone.js.map
